import { ChemicalLot } from "./chemical-lot";
import { Comment } from "./comment";
import { Step } from "./step";

export class BeadChip{
    beadChipID: string;
    active: boolean;
    sourcePlateID: string;
    singleRedo: boolean;
    plateRedo: boolean;
    processSteps: Step[];
    status: string;
    comments: Comment[];
    lots: ChemicalLot[];
    otherBeadChipStatus: string;
    sampleIDs: string[];
    minimumTemperature: string;
    maximumTemperature: string;
    workFlow: string;
    archiveData: any[];
}